import * as React from "react";

import { NavBar } from "./NavBar";
import { NavBarProvider } from "./NavBarProvider";

interface NavigationProps {
  activePath: string;
  user: {
    account: {
      name: string;
    };
    id: string;
    name: string;
  };
}

export function Navigation({ activePath, user }: NavigationProps) {
  return (
    <NavBarProvider>
      <NavBar activePath={activePath} user={user} />
    </NavBarProvider>
  );
}
